module.exports = __webpack_public_path__ + "img/home.98c008d2.png";